import React from "react";
import "./styles.css";

// mobres.com'a backlink. nofollow YOK — arama motorları için sayılan link.
// variant="light" koyu zemin (giriş ekranı) üzerinde kullanılır.
// noreferrer bilerek yok: mobres.com trafiğin hangi menüden geldiğini görebilsin.
const MobresBacklink = ({ variant = "dark" }) => (
  // eslint-disable-next-line react/jsx-no-target-blank
  <a
    className={`mobres-backlink mobres-backlink--${variant}`}
    href="https://mobres.com"
    target="_blank"
    rel="noopener"
  >
    <span>Bu dijital menü</span> <strong>Mobres</strong> <span>ile hazırlanmıştır</span>
  </a>
);

export default MobresBacklink;
